/**
 * CategoriasCarrusel: Carrusel horizontal de categorías circulares
 * estilo Bonda / Cuponstar. Reemplaza la grilla rectangular tradicional.
 */
import React, { useRef } from 'react';
import { Gift, ChevronLeft, ChevronRight } from 'lucide-react';

export default function CategoriasCarrusel({
  categorias = [],
  categoriaFiltro,
  onSelect,
  iconMap = {},
  testId = 'categorias-carrusel',
}) {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: dir * 300, behavior: 'smooth' });
  };

  const items = [
    { id: null, nombre: 'Todo', icono: null, esTodo: true },
    ...categorias,
  ];

  return (
    <div className="relative" data-testid={testId}>
      {/* Flechas navegación (desktop) */}
      <button
        onClick={() => scroll(-1)}
        className="hidden md:flex absolute -left-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 bg-white shadow-md rounded-full items-center justify-center hover:bg-gray-50 border border-gray-200"
        aria-label="Desplazar a la izquierda"
        data-testid={`${testId}-prev`}
      >
        <ChevronLeft className="w-4 h-4 text-gray-700" />
      </button>
      <button
        onClick={() => scroll(1)}
        className="hidden md:flex absolute -right-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 bg-white shadow-md rounded-full items-center justify-center hover:bg-gray-50 border border-gray-200"
        aria-label="Desplazar a la derecha"
        data-testid={`${testId}-next`}
      >
        <ChevronRight className="w-4 h-4 text-gray-700" />
      </button>

      <div
        ref={scrollRef}
        className="overflow-x-auto scrollbar-thin -mx-2 px-2 pb-2"
        style={{ scrollbarWidth: 'thin' }}
      >
        <div className="flex gap-3 sm:gap-4 min-w-max py-2">
          {items.map((cat) => {
            const Icon = cat.esTodo ? Gift : iconMap[cat.icono] || Gift;
            const activa = categoriaFiltro === cat.id;
            return (
              <button
                key={cat.id || 'todo'}
                onClick={() => onSelect(activa && !cat.esTodo ? null : cat.id)}
                className="group flex flex-col items-center gap-2 flex-shrink-0 w-20 sm:w-24"
                data-testid={cat.esTodo ? 'cat-todas' : `cat-${cat.id}`}
              >
                <div
                  className={`w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center transition-all border-2 ${
                    activa
                      ? 'bg-purple-600 border-purple-600 text-white shadow-lg shadow-purple-200 scale-105'
                      : 'bg-white border-purple-100 text-purple-600 group-hover:border-purple-300 group-hover:shadow-md'
                  }`}
                >
                  <Icon className="w-7 h-7 sm:w-8 sm:h-8" />
                </div>
                <span
                  className={`text-[11px] sm:text-xs font-medium text-center leading-tight px-1 line-clamp-2 ${
                    activa ? 'text-purple-800 font-semibold' : 'text-gray-700'
                  }`}
                  title={cat.nombre}
                >
                  {cat.nombre}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
